module.exports = __webpack_public_path__ + "static/unifi1-5ff8454a1cde2cbde6c79ae3dd39803e.png";